var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAusFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2549_1296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.84961C16 13.2679 12.4183 16.8496 8 16.8496C3.58175 16.8496 0 13.2679 0 8.84961C0 8.85148 8 0.850516 8 0.849609C12.4183 0.849609 16 4.43136 16 8.84961Z",
    fill: "#1943DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97852 8.85006H7.99996C7.99996 8.84279 7.99996 8.83584 7.99996 8.82861C7.99283 8.83578 7.98569 8.84292 7.97852 8.85006Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.02425C8 3.61659 8 2.69419 8 0.850342H7.99865C3.581 0.851061 0 4.43247 0 8.85031H4.1739V6.49993L6.52428 8.85031H7.97862C7.98578 8.84318 7.9929 8.83606 8.00003 8.8289C8.00003 8.28993 8.00003 7.80903 8.00003 7.37465L5.64962 5.02425H8Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04782 1.89355C2.7966 2.60602 1.75641 3.64621 1.04395 4.89743V8.85009H3.13091V3.98056V3.98052H8.00048C8.00048 3.3223 8.00048 2.69524 8.00048 1.89355H4.04782Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00086 7.86644L5.15858 5.02418H4.1748C4.1748 5.02415 4.1748 5.02418 4.1748 5.02418L8.00083 8.85022H8.00086C8.00086 8.85022 8.00086 8.17194 8.00086 7.86644Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82486 10.2407L5.26392 11.1588L6.25539 10.9296L5.81139 11.8453L6.6087 12.4776L5.61598 12.7013L5.61877 13.719L4.82486 13.0823L4.03098 13.719L4.03377 12.7013L3.04102 12.4776L3.83836 11.8453L3.3943 10.9296L4.38583 11.1588L4.82486 10.2407Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9778 11.98L12.1974 12.439L12.6931 12.3244L12.4711 12.7823L12.8698 13.0984L12.3734 13.2103L12.3748 13.7191L11.9778 13.4008L11.5809 13.7191L11.5823 13.2103L11.0859 13.0984L11.4846 12.7823L11.2626 12.3244L11.7583 12.439L11.9778 11.98Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93491 7.1106L10.1544 7.56966L10.6502 7.45503L10.4282 7.91288L10.8268 8.22903L10.3305 8.34091L10.3318 8.84972L9.93491 8.53138L9.53797 8.84972L9.53931 8.34091L9.04297 8.22903L9.44162 7.91288L9.21963 7.45503L9.71537 7.56966L9.93491 7.1106Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9778 4.32812L12.1974 4.78719L12.6931 4.67259L12.4711 5.13044L12.8697 5.44656L12.3734 5.55847L12.3748 6.06728L11.9778 5.74894L11.5809 6.06728L11.5823 5.55847L11.0859 5.44656L11.4846 5.13044L11.2626 4.67259L11.7583 4.78719L11.9778 4.32812Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7611 6.41479L13.9806 6.87386L14.4763 6.75923L14.2543 7.21708L14.653 7.53323L14.1566 7.64514L14.158 8.15392L13.7611 7.83561L13.3641 8.15392L13.3655 7.64514L12.8691 7.53323L13.2678 7.21708L13.0458 6.75923L13.5415 6.87386L13.7611 6.41479Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4864 8.84985L12.659 9.38129H13.2178L12.7657 9.70976L12.9384 10.2412L12.4864 9.91273L12.0343 10.2412L12.2069 9.70976L11.7549 9.38129H12.3137L12.4864 8.84985Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2549_1296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.849609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAusFlag);
export default __webpack_public_path__ + "static/media/ausFlag.b717f92abb33dbe8c80210a3a13b919a.svg";
export { ForwardRef as ReactComponent };